export default {
    namespace: 'PersonalizedService',
    translations: {
        zh: {
            hero: {
                kicker: 'TO B&G SERVICE',
                title: '个性化服务',
                description: '全洞察、强合规、快落地、深扎根，旨在将出海的不确定性转化为可预期、可管理、可增长的系统工程。'
            },
            sections: {
                oneStop: {
                    label: 'GLOBAL EXPANSION',
                    title: '科技企业出海一站式服务',
                    processTitle: '服务流程',
                    processItems: [
                        {
                            title: '市场调研',
                            description: '目前市场调查、出海策略制定、行业趋势分析、可行性研究。'
                        },
                        {
                            title: '合规性对策',
                            description: '公司注册、税务合规、劳动法对应，并识别和管理潜在业务风险。'
                        },
                        {
                            title: '营销基础搭建',
                            description: '提供人力资源服务、搭建供应链体系，并支持本地化营销推广、人员培训与团队养成。'
                        },
                        {
                            title: '行业咨询',
                            description: '围绕行业商务考察定制化、展会活动定制化以及销售数据分析，持续提供决策支持。'
                        },
                        {
                            title: '产品服务',
                            description: '覆盖软硬件产品开发和迭代服务，以及产品售后服务本地化。'
                        }
                    ],
                    advantageTitle: '2. 我们服务的四大优势',
                    advantages: [
                        {
                            title: '智能诊断',
                            description: '始于数据，忠于洞察。我们运用大数据与行业智能分析工具，对区域产业基础、技术密度、人才结构和链位优势进行精准扫描与评估，明确核心潜力与升级瓶颈，为科学决策提供清晰的数字化底图。'
                        },
                        {
                            title: '战略规划',
                            description: '基于诊断，定义未来。我们结合全球技术趋势与本地禀赋，协助制定聚焦于人工智能、智能制造等前沿方向的产业升级路线图，明确阶段性目标、关键举措与核心赛道，将宏观愿景转化为可执行、可评估的行动蓝图。'
                        },
                        {
                            title: '生态赋能',
                            description: '连接全球资源，激活本地创新。我们调动东京 AI 社区、科研机构及产业合作伙伴网络，定向引入技术、资本、导师与高端人才，为企业和创业者提供全要素成长支持，加速项目孵化和技术产业化。'
                        },
                        {
                            title: '持续进化',
                            description: '建立反馈循环，实现迭代成长。我们协助构建产业发展的动态监测与评估体系，跟踪企业成长、生态健康度与目标达成情况，形成“评估 - 优化 - 再增长”的正向循环，确保产业生态拥有持久的竞争力与适应性。'
                        }
                    ]
                },
                custom: {
                    label: 'CUSTOMIZED SERVICE',
                    title: '定制化服务（开发/孵化/创业/产业）',
                    items: [
                        {
                            index: '1',
                            title: '项目开发定制化',
                            points: [
                                {
                                    title: '精准需求落地',
                                    description: '深度拆解生产管理、办公协同等差异化业务诉求，量身定制专属软件方案，确保功能与场景高度适配。'
                                },
                                {
                                    title: 'AI 赋能高效开发',
                                    description: '以 AI 辅助代码生成、自动化测试与智能优化，大幅缩短开发周期，提升交付质量。'
                                },
                                {
                                    title: '全流程交付保障',
                                    description: '覆盖方案设计、开发测试、上线部署、售后运维全周期，适配多语言、跨境合规等海外场景，稳定可靠。'
                                },
                                {
                                    title: '持续迭代优化',
                                    description: '依托系统巡检与快速响应机制，支持功能升级与业务适配，保障软件长期高效运行。'
                                }
                            ],
                            caseTitle: '优秀案例',
                            cases: [
                                {
                                    title: 'Overseas 卡牌电商网站和 APP 开发项目',
                                    imageKey: 'cards'
                                }
                            ]
                        },
                        {
                            index: '2',
                            title: '产品孵化定制化',
                            points: [
                                {
                                    title: '政策与产业精准对接',
                                    description: '立足国家战略与地方产业，定制精准产业政策，对接高成长科技企业，高效释放政策资金效能。'
                                },
                                {
                                    title: '主动构建技术生态',
                                    description: '产业升级的核心在于技术跃迁。我们依托 AI 与全球资源，为区域导入前沿技术与科研力量，打造具备自我造血能力的创新生态，集聚高端要素。'
                                },
                                {
                                    title: '全周期赋能企业成长',
                                    description: '为种子期至龙头企业提供全周期政策性赋能，降低制度性成本，助力企业专注技术研发与市场开拓。'
                                },
                                {
                                    title: '可持续模式构建',
                                    description: '共建韧性强、内生增长的产业体系，统筹企业与产业链协同发展，构建孵化反哺的良性循环。'
                                }
                            ],
                            caseTitle: '优秀案例',
                            cases: [
                                {
                                    title: 'NAS 软硬件开发项目',
                                    imageKey: 'nas'
                                }
                            ]
                        },
                        {
                            index: '3',
                            title: '创业活动定制化',
                            lead: '突破传统招商模式，搭建精准高效的价值对接平台。',
                            paragraphs: [
                                '依托全球科技产业链洞察与数据智能分析，定制目标筛选、触点策划、落地对接全流程招商方案。',
                                '围绕人工智能、高端制造等前沿领域开展专题推介，组织中日创新资源对接考察，吸引优质企业与项目落地，提升招商转化率与产业凝聚力。'
                            ],
                            caseTitle: '优秀案例',
                            cases: [
                                {
                                    title: '中日创新资源对接考察活动案例',
                                    placeholderTone: 'investment'
                                }
                            ]
                        },
                        {
                            index: '4',
                            title: '产业升级定制化',
                            lead: '激活区域创新活力，构筑创业生态雨林。',
                            paragraphs: [
                                '以有温度、能成长、见实效的创业生态为起点，打造贯穿全周期的品牌活动矩阵，覆盖前沿技术 Workshop、国际创业大赛、创始人社群、投融资对接会等多元场景。',
                                '注入全球视野、实战导师与产业资源，助力本地创业者加速成长，吸引外部创新力量汇聚，构建自我驱动、开放共赢的区域创新创业生态。'
                            ],
                            caseTitle: '优秀案例',
                            cases: [
                                {
                                    title: '国际创业大赛与创始人社群活动案例',
                                    placeholderTone: 'startup'
                                }
                            ]
                        }
                    ]
                },
                strengths: {
                    label: 'OUR ADVANTAGES',
                    title: '我们的优势',
                    intro: '全洞察、强合规、快落地、深扎根，旨在将出海的不确定性转化为可预期、可管理、可增长的系统工程。',
                    items: [
                        {
                            title: '决策有据',
                            description: '确保战略规划始于清晰的事实与趋势，而非模糊的经验。'
                        },
                        {
                            title: '风险可控',
                            description: '由熟悉中日双边法规的专家团队主导，将合规要求融入市场进入与运营流程。'
                        },
                        {
                            title: '启动高效',
                            description: '提供从品牌定位、数字渠道到本地化内容的营销基础快速搭建服务。'
                        },
                        {
                            title: '智库伴随',
                            description: '连接中日产业专家与智库资源，提供持续、动态的行业咨询服务。'
                        },
                        {
                            title: '产品穿透',
                            description: '超越咨询建议，协助企业完成核心产品或服务的本地化适配与试点验证。'
                        },
                        {
                            title: '生态链接',
                            description: '为企业嫁接长期的技术、人才与合作伙伴网络，实现“生态位融入”。'
                        }
                    ]
                }
            }
        },
        en: {
            hero: {
                kicker: 'TO B&G SERVICE',
                title: 'Personalized Services (TO B&G)',
                description: 'Full-spectrum insight, strong compliance, fast execution, and deep local grounding, turning uncertainty in global expansion into a predictable, manageable, and scalable system.'
            },
            sections: {
                oneStop: {
                    label: 'GLOBAL EXPANSION',
                    title: 'One-stop Global Expansion Services for Technology Enterprises',
                    processTitle: 'Service Process',
                    processItems: [
                        {
                            title: 'Market Research',
                            description: 'Current market assessment, go-global strategy design, industry trend analysis, and feasibility studies.'
                        },
                        {
                            title: 'Compliance Measures',
                            description: 'Company registration, tax compliance, labor law alignment, and identification and management of potential business risks.'
                        },
                        {
                            title: 'Marketing Foundation Setup',
                            description: 'Human resources support, supply chain system setup, localized marketing and promotion, plus training and team development.'
                        },
                        {
                            title: 'Industry Consulting',
                            description: 'Customized business visits, tailored exhibition and event planning, and sales data analysis for ongoing decision support.'
                        },
                        {
                            title: 'Product Services',
                            description: 'Software and hardware product development and iteration services, together with localized after-sales support.'
                        }
                    ],
                    advantageTitle: '2. Four Core Advantages of Our Services',
                    advantages: [
                        {
                            title: 'Intelligent Diagnosis',
                            description: 'Grounded in data and driven by insight, we use big data and industry intelligence tools to scan and assess regional industrial foundations, technology density, talent structure, and value-chain positioning, helping clarify both potential and bottlenecks.'
                        },
                        {
                            title: 'Strategic Planning',
                            description: 'Based on the diagnosis, we help define the future by combining global technology trends with local strengths and building clear upgrade roadmaps around frontier sectors such as AI and intelligent manufacturing.'
                        },
                        {
                            title: 'Ecosystem Empowerment',
                            description: 'We connect global resources and activate local innovation by mobilizing the Tokyo AI community, research institutions, and industry partners to introduce technology, capital, mentors, and high-end talent.'
                        },
                        {
                            title: 'Continuous Evolution',
                            description: 'We help build dynamic monitoring and evaluation systems that create a positive cycle of assessment, optimization, and renewed growth, ensuring long-term competitiveness and adaptability.'
                        }
                    ]
                },
                custom: {
                    label: 'CUSTOMIZED SERVICE',
                    title: 'Customized Services (Development / Incubation / Investment Promotion / Entrepreneurship)',
                    items: [
                        {
                            index: '1',
                            title: 'Customized Project Development',
                            points: [
                                {
                                    title: 'Precise Requirement Delivery',
                                    description: 'We deeply break down differentiated business needs in production management, office collaboration, and beyond to design tailored software solutions with a strong fit to real operating scenarios.'
                                },
                                {
                                    title: 'AI-powered Efficient Development',
                                    description: 'By using AI-assisted code generation, automated testing, and intelligent optimization, we significantly shorten development cycles and improve delivery quality.'
                                },
                                {
                                    title: 'End-to-end Delivery Assurance',
                                    description: 'From solution design and development testing to deployment and after-sales operations, we cover the full lifecycle and adapt to multilingual and cross-border compliance requirements.'
                                },
                                {
                                    title: 'Continuous Iteration and Optimization',
                                    description: 'With system inspections and rapid response mechanisms, we support functional upgrades and business adaptation to keep software running efficiently over the long term.'
                                }
                            ],
                            caseTitle: 'Case Study',
                            cases: [
                                {
                                    title: 'Overseas Trading Card E-commerce Website and App Development Project',
                                    imageKey: 'cards'
                                }
                            ]
                        },
                        {
                            index: '2',
                            title: 'Industrial Incubation Upgrade',
                            points: [
                                {
                                    title: 'Precise Policy and Industry Alignment',
                                    description: 'Rooted in national strategy and local industries, we tailor precise industrial policies, connect with high-growth technology enterprises, and improve the efficiency of policy support.'
                                },
                                {
                                    title: 'Proactive Technology Ecosystem Building',
                                    description: 'Since industrial upgrading depends on technological leaps, we use AI and global resources to bring in frontier technologies and research capability and build a self-sustaining innovation ecosystem.'
                                },
                                {
                                    title: 'Full-cycle Enterprise Empowerment',
                                    description: 'We provide policy-driven support across the lifecycle from seed-stage companies to industry leaders, reducing institutional costs and helping enterprises focus on R&D and market expansion.'
                                },
                                {
                                    title: 'Sustainable Model',
                                    description: 'We co-build resilient, internally driven industrial systems, coordinating enterprise development with industrial chain development and forming a virtuous cycle in which incubation supports future growth.'
                                }
                            ],
                            caseTitle: 'Case Study',
                            cases: [
                                {
                                    title: 'NAS Software and Hardware Development Project',
                                    imageKey: 'nas'
                                }
                            ]
                        },
                        {
                            index: '3',
                            title: 'Customized Investment Promotion Activities',
                            lead: 'Move beyond traditional investment attraction models and build an efficient, high-precision value-matching platform.',
                            paragraphs: [
                                'Leveraging global technology industry-chain insight and data intelligence, we design full-process investment promotion programs covering target screening, touchpoint planning, and on-the-ground matchmaking.',
                                'Focusing on frontier sectors such as AI and advanced manufacturing, we organize themed promotion events and China-Japan innovation exchange visits to attract high-quality enterprises and projects and improve conversion and industrial cohesion.'
                            ],
                            caseTitle: 'Case Study',
                            cases: [
                                {
                                    title: 'China-Japan Innovation Matchmaking Visit Program',
                                    placeholderTone: 'investment'
                                }
                            ]
                        },
                        {
                            index: '4',
                            title: 'Customized Entrepreneurship Activities',
                            lead: 'Activate regional innovation vitality and cultivate a rainforest-like startup ecosystem.',
                            paragraphs: [
                                'Starting from a warm, growth-oriented, and results-driven entrepreneurial environment, we build a full-cycle brand activity matrix, including frontier technology workshops, international startup competitions, founder communities, and financing matchmaking events.',
                                'By bringing in global perspectives, experienced mentors, and industry resources, we help local entrepreneurs grow faster, attract outside innovators, and create an open, self-driven, and mutually beneficial regional innovation ecosystem.'
                            ],
                            caseTitle: 'Case Study',
                            cases: [
                                {
                                    title: 'International Startup Competition and Founder Community Program',
                                    placeholderTone: 'startup'
                                }
                            ]
                        }
                    ]
                },
                strengths: {
                    label: 'OUR ADVANTAGES',
                    title: 'Our Advantages',
                    intro: 'Full-spectrum insight, strong compliance, fast execution, and deep local grounding, turning uncertainty in global expansion into a predictable, manageable, and scalable system.',
                    items: [
                        {
                            title: 'Evidence-based Decisions',
                            description: 'Strategic planning starts from clear facts and trends rather than vague experience.'
                        },
                        {
                            title: 'Controllable Risk',
                            description: 'Led by experts familiar with both Chinese and Japanese regulations, we embed compliance into market entry and operational processes.'
                        },
                        {
                            title: 'Efficient Launch',
                            description: 'We rapidly build the marketing foundation, from brand positioning and digital channels to localized content.'
                        },
                        {
                            title: 'Think Tank Support',
                            description: 'We connect enterprises with China-Japan industry experts and think tank resources for continuous, dynamic advisory support.'
                        },
                        {
                            title: 'Product Penetration',
                            description: 'We go beyond consulting recommendations to help localize core products or services and validate pilot execution.'
                        },
                        {
                            title: 'Ecosystem Connection',
                            description: 'We bridge enterprises to long-term networks of technology, talent, and partners to achieve true ecosystem integration.'
                        }
                    ]
                }
            }
        },
        ja: {
            hero: {
                kicker: 'TO B&G SERVICE',
                title: '個別化サービス（TO B&G）',
                description: '多面的な洞察、強いコンプライアンス、迅速な実行、そして深い現地定着力によって、海外展開の不確実性を予測可能で管理可能な成長システムへと変えていきます。'
            },
            sections: {
                oneStop: {
                    label: 'GLOBAL EXPANSION',
                    title: 'テクノロジー企業向け海外進出ワンストップサービス',
                    processTitle: 'サービスプロセス',
                    processItems: [
                        {
                            title: '市場調査',
                            description: '現地市場調査、海外進出戦略の策定、業界トレンド分析、実行可能性調査を行います。'
                        },
                        {
                            title: 'コンプライアンス対策',
                            description: '会社設立、税務コンプライアンス、労働法対応、潜在的な事業リスクの把握と管理を支援します。'
                        },
                        {
                            title: 'マーケティング基盤構築',
                            description: '人材支援、サプライチェーン構築、ローカライズされたマーケティングと販促、研修とチーム育成を提供します。'
                        },
                        {
                            title: '業界コンサルティング',
                            description: '業界視察の個別設計、展示会イベントのカスタマイズ、販売データ分析を通じて継続的な意思決定支援を行います。'
                        },
                        {
                            title: '製品サービス',
                            description: 'ソフトウェア・ハードウェア製品の開発および改善、さらにアフターサービスの現地化まで対応します。'
                        }
                    ],
                    advantageTitle: '2. 私たちの4つの強み',
                    advantages: [
                        {
                            title: 'インテリジェント診断',
                            description: 'データに基づき、洞察を重視します。ビッグデータと業界分析ツールを用いて、地域産業の基盤、技術密度、人材構成、バリューチェーン上の優位性を精密に可視化し、成長余地と課題を明確にします。'
                        },
                        {
                            title: '戦略設計',
                            description: '診断結果をもとに未来を定義します。世界の技術潮流と地域の強みを組み合わせ、AIやスマート製造などの先端分野に焦点を当てた産業高度化ロードマップを策定します。'
                        },
                        {
                            title: 'エコシステム支援',
                            description: 'グローバル資源をつなぎ、地域イノベーションを活性化します。東京AIコミュニティ、研究機関、産業パートナーと連携し、技術・資本・メンター・高度人材を導入します。'
                        },
                        {
                            title: '継続進化',
                            description: '評価、最適化、再成長の循環をつくるため、動的なモニタリングと評価の仕組みを整え、長期的な競争力と適応力を支えます。'
                        }
                    ]
                },
                custom: {
                    label: 'CUSTOMIZED SERVICE',
                    title: 'カスタマイズサービス（開発 / インキュベーション / 招商 / 起業）',
                    items: [
                        {
                            index: '1',
                            title: 'プロジェクト開発の個別対応',
                            points: [
                                {
                                    title: '精緻な要件実装',
                                    description: '生産管理や業務協働などの多様なニーズを深く整理し、現場に適した専用ソフトウェアソリューションを設計します。'
                                },
                                {
                                    title: 'AI による高効率開発',
                                    description: 'AI支援のコード生成、自動テスト、最適化により、開発期間を短縮し、納品品質を高めます。'
                                },
                                {
                                    title: '全工程の納品保証',
                                    description: '設計、開発、検証、公開、運用保守まで一貫して対応し、多言語や越境コンプライアンスを含む海外シーンにも適応します。'
                                },
                                {
                                    title: '継続的な改善',
                                    description: 'システム点検と迅速な対応体制を通じて、機能拡張や業務変化への適応を支えます。'
                                }
                            ],
                            caseTitle: '導入事例',
                            cases: [
                                {
                                    title: '海外向けトレーディングカードECサイト・アプリ開発プロジェクト',
                                    imageKey: 'cards'
                                }
                            ]
                        },
                        {
                            index: '2',
                            title: '産業インキュベーション高度化',
                            points: [
                                {
                                    title: '政策と産業の精密連携',
                                    description: '国家戦略と地域産業に基づき、精密な産業政策を設計し、高成長テック企業との接続を強化します。'
                                },
                                {
                                    title: '技術エコシステムの能動的構築',
                                    description: 'AIとグローバル資源を活用し、先端技術と研究力を導入して、自律成長するイノベーション基盤を形成します。'
                                },
                                {
                                    title: '企業成長への全周期支援',
                                    description: 'シード期から業界リーダーまで、政策的支援を一貫して提供し、制度コストを抑えながら研究開発と市場開拓に集中できる環境を整えます。'
                                },
                                {
                                    title: '持続可能なモデル',
                                    description: '企業と産業チェーンの発展を統合し、インキュベーションが次の成長を生む好循環を構築します。'
                                }
                            ],
                            caseTitle: '導入事例',
                            cases: [
                                {
                                    title: 'NAS ソフトウェア・ハードウェア開発プロジェクト',
                                    imageKey: 'nas'
                                }
                            ]
                        },
                        {
                            index: '3',
                            title: '招商イベントの個別設計',
                            lead: '従来型の招商モデルを超え、精度と効率の高い価値接続プラットフォームを構築します。',
                            paragraphs: [
                                '世界のテクノロジー産業チェーンに対する洞察とデータ分析をもとに、対象選定、接点設計、現地マッチングまで含む一連の招商プログラムを設計します。',
                                'AIや先端製造などの重点分野を中心に、テーマ別プロモーションや日中イノベーション視察を企画し、優良企業とプロジェクトの誘致を促進します。'
                            ],
                            caseTitle: '導入事例',
                            cases: [
                                {
                                    title: '日中イノベーション資源マッチング視察事例',
                                    placeholderTone: 'investment'
                                }
                            ]
                        },
                        {
                            index: '4',
                            title: '起業イベントの個別設計',
                            lead: '地域のイノベーション活力を高め、起業エコシステムの雨林を育てます。',
                            paragraphs: [
                                '温かさがあり、成長でき、成果につながる起業環境を起点に、先端技術ワークショップ、国際スタートアップ大会、創業者コミュニティ、資金調達マッチング会などの全周期ブランド活動を構築します。',
                                'グローバル視点、実戦型メンター、産業資源を導入し、地域の起業家の成長を加速させるとともに、外部の革新力を呼び込みます。'
                            ],
                            caseTitle: '導入事例',
                            cases: [
                                {
                                    title: '国際スタートアップ大会・創業者コミュニティ事例',
                                    placeholderTone: 'startup'
                                }
                            ]
                        }
                    ]
                },
                strengths: {
                    label: 'OUR ADVANTAGES',
                    title: '私たちの強み',
                    intro: '多面的な洞察、強いコンプライアンス、迅速な実行、そして深い現地定着力によって、海外展開の不確実性を予測可能で管理可能な成長システムへと変えていきます。',
                    items: [
                        {
                            title: '根拠ある意思決定',
                            description: '曖昧な経験ではなく、明確な事実とトレンドから戦略を組み立てます。'
                        },
                        {
                            title: 'コントロール可能なリスク',
                            description: '中日双方の法規制に精通した専門チームが、コンプライアンスを市場参入と運営プロセスに組み込みます。'
                        },
                        {
                            title: '迅速な立ち上げ',
                            description: 'ブランド設計、デジタルチャネル、ローカライズされたコンテンツまで、マーケティング基盤を素早く構築します。'
                        },
                        {
                            title: '伴走型シンクタンク',
                            description: '中日産業の専門家やシンクタンク資源を結び、継続的で動的な業界支援を行います。'
                        },
                        {
                            title: '製品への深い浸透',
                            description: '助言にとどまらず、製品やサービスの現地適応と試験導入まで支援します。'
                        },
                        {
                            title: 'エコシステム接続',
                            description: '技術、人材、パートナーの長期的ネットワークを企業へ接続し、真のエコシステム統合を実現します。'
                        }
                    ]
                }
            }
        }
    }
};
